import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LoadingScreen, OverlaySidebar } from '@lendica/components';
// import { useAppContext } from '../hooks/useContext';
import { PdfViewer } from '../components/PdfViewer';
import { InvoiceSummary } from './InvoicePdfViewer';
import { usePayLaterApi } from '../payLaterAPI';
import { Bill } from '@lendica/utils';
import { RowType } from '../sharedTypes';

export const InvoicePdfViewerResponsive: FC<{
    collapsible?: boolean;
}> = ({ collapsible }) => {
    const { billId, type } = useParams<{ billId: string; type: RowType }>();
    const [filename, setFilename] = useState<string | null>(null);
    const [invoice, setInvoice] = useState<Bill | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const api = usePayLaterApi();
    // const appContext = useAppContext();

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                setFilename(null);
                if (type === RowType.Bill) {
                    const data = await api.getBill(billId!);
                    setInvoice(data);
                    setFilename(data.filename);
                } else {
                    setFilename((await api.getDeal(billId!)).filename);
                }
            } catch (e) {
                console.log(e);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 100);
            }
        })();
    }, [billId]);

    const content =
        filename !== null && filename!.length > 0 ? (
            <PdfViewer invoices={[{ name: '', filename }]} />
        ) : (
            <InvoiceSummary invoice={invoice} />
        );

    if (loading) {
        return <LoadingScreen />;
    }

    // Use OverlaySidebar for dashboard, SidePanelLayout for iBranch
    // if (appContext === 'dashboard') {
    return (
        <OverlaySidebar redirectRoute="/paylater" loading={loading} open={true}>
            {content}
        </OverlaySidebar>
    );
    // }

    // iBranch context - use existing SidePanelLayout
    // return (
    //     <SidePanelLayout redirectRoute="/paylater" collapsible={collapsible} loading={loading}>
    //         {content}
    //     </SidePanelLayout>
    // );
};
